import API from '../index';
import { Parcel, Address, HoldAtLocation, ShipmentType } from '../../types/common';
import { getPresetSize } from '../../containers/Packages/utils';

interface Request {
  address: Partial<Address>;
  country: string;
  parcels: Parcel[];
  shipmentType: ShipmentType;
}

interface Response {
  locations: {
    locationId: string;
    address: {
      type: string;
      state: string;
      city: string;
      postalCode: string;
      street1: string;
      companyName: string;
      country: string;
    };
  }[];
}

const convertAddress = (
  { street, city, state = '', postalCode = '' }: Partial<Address>,
  country: string,
) => ({
  company: '',
  country,
  name: 'Dummy name here',
  phone: '',
  phoneExt: '',
  state: state,
  street1: street,
  street2: '',
  city,
  zip: postalCode,
});

const convertParcelsToBoxes = (parcels: Parcel[]) =>
  parcels.map(({ length, width, height, weight }) => ({
    length,
    width,
    height,
    weight,
    quantity: 1,
  }));

const convertDocumentToBoxes = () => {
  const { length, width, height, weight } = getPresetSize('envelope', ShipmentType.DOCUMENT);
  return [
    {
      length,
      width,
      height,
      weight,
      quantity: 1,
    },
  ];
};

const parseResponse = ({ locations }: Response): HoldAtLocation[] => {
  return locations.map(({ locationId, address }) => {
    const { state, city, postalCode, street1: street, companyName } = address;
    return {
      locationId,
      address: { state, city, postalCode, street, companyName },
    };
  });
};

const getHoldAtLocations = async ({
  address,
  country,
  parcels,
  shipmentType,
}: Request): Promise<HoldAtLocation[]> => {
  const parsedAddress = convertAddress(address, country);
  const boxes =
    shipmentType === ShipmentType.DOCUMENT
      ? convertDocumentToBoxes()
      : convertParcelsToBoxes(parcels);

  const result: Response = await API.post(`/fedex-hal-locations`, {
    address: parsedAddress,
    boxes,
  });

  return parseResponse(result);
};

export default getHoldAtLocations;
